export enum StereotypesTranslationKey {
    ADD_STEREOTYPE = "stereotypes.addStereotype",
    ATTRIBUTE_CREATED_SUCCESSFULLY = "stereotypes.attributeCreatedSuccessfully",
    ATTRIBUTE_DELETED_SUCCESSFULLY = "stereotypes.attributeDeletedSuccessfully",
    ATTRIBUTE_WILL_BE_DELETED = "stereotypes.attributeWillBeDeleted",
    ATTRIBUTE_WITH_SAME_NAME_ALREADY_EXISTS = "stereotypes.attributeWithSameNameAlreadyExists",
    ATTRIBUTES = "stereotypes.attributes",
    BASE_TYPE = "stereotypes.baseType",
    COMPONENT_RENDERING_ERROR = "stereotypes.componentRenderingError",
    CURRENCY = "stereotypes.currency",
    DATA_TYPE = "stereotypes.dataType",
    DEFAULT_VALUE = "stereotypes.defaultValue",
    DELETE_ATTRIBUTE_PROMPT = "stereotypes.deleteAttributePrompt",
    DELETE_SMART_REFERENCE_PROMPT = "stereotypes.deleteSmartReferencePrompt",
    DELETE_STEREOTYPE = "stereotypes.deleteStereotype",
    DETAILS = "stereotypes.details",
    EDIT_ELEMENT_FILTER = "stereotypes.editElementFilter",
    EDIT_SMART_REFERENCE = "stereotypes.editSmartReference",
    EDIT_STEREOTYPE = "stereotypes.editStereotype",
    ELEMENT_FILTER = "stereotypes.elementFilter",
    GENERATE_LAYOUT = "stereotypes.generateLayout",
    IDENTIFIER = "stereotypes.identifier",
    GENERATE_IDENTIFIER = "stereotypes.generateIdentifier",
    CUSTOM_IDENTIFIER = "stereotypes.customIdentifier",
    INVALID_LAYOUT_FORMAT = "stereotypes.invalidLayoutFormat",
    LAYOUT = "stereotypes.layout",
    MULTIPLE = "stereotypes.multiple",
    NAME = "stereotypes.name",
    NEW_ATTRIBUTE = "stereotypes.newAttribute",
    NEW_SMART_REFERENCE = "stereotypes.newSmartReference",
    NEW_STEREOTYPE = "stereotypes.newStereotype",
    RELATIONSHIP_DIRECTION = "stereotypes.relationshipDirection",
    RELATIONSHIP_TYPE = "stereotypes.relationshipType",
    REQUIRED = "stereotypes.required",
    SMART_REFERENCE = "stereotypes.smartReference",
    SMART_REFERENCES = "stereotypes.smartReferences",
    SMART_REFERENCE_DELETED_SUCCESSFULLY = "stereotypes.smartReferenceDeletedSuccessfully",
    SMART_REFERENCE_REQUIRED = "stereotypes.smartReferenceRequired",
    SMART_REFERENCE_WILL_BE_DELETED = "stereotypes.smartReferenceWillBeDeleted",
    STEREOTYPE = "stereotypes.stereotype",
    STEREOTYPE_CREATED_SUCCESSFULLY = "stereotypes.stereotypeCreatedSuccessfully",
    STEREOTYPE_DELETED_SUCCESSFULLY = "stereotypes.stereotypeDeletedSuccessfully",
    STEREOTYPE_WILL_BE_DELETED = "stereotypes.stereotypeWillBeDeleted",
    STEREOTYPE_WITH_SAME_NAME_ALREADY_EXISTS = "stereotypes.stereotypeWithSameNameAlreadyExists",
    STEREOTYPE_WITH_SAME_IDENTIFIER_ALREADY_EXISTS = "stereotypes.stereotypeWithSameIdentifierAlreadyExists",
    INVALID_IDENTIFIER_FORMAT = "stereotypes.invalidIdentifierFormat",
    STEREOTYPES = "stereotypes.stereotypes",
    UNKNOWN_ATTRIBUTE = "stereotypes.unknownAttribute",
    UNKNOWN_REFERENCE = "stereotypes.unknownReference",
    VALUE_IS_ABOVE_ALLOWED_LIMIT = "stereotypes.valueIsAboveAllowedLimit",
    VALUE_IS_BELLOW_ALLOWED_LIMIT = "stereotypes.valueIsBellowAllowedLimit",
    VALUE_IS_NOT_VALID_BOOLEAN = "stereotypes.valueIsNotValidBoolean",
    VALUE_IS_NOT_VALID_CURRENCY = "stereotypes.valueIsNotValidCurrency",
    VALUE_IS_NOT_VALID_DATE = "stereotypes.valueIsNotValidDate",
    VALUE_IS_NOT_VALID_DATE_TIME = "stereotypes.valueIsNotValidDateTime",
    VALUE_IS_NOT_VALID_FLOAT = "stereotypes.valueIsNotValidFloat",
    VALUE_IS_NOT_VALID_INTEGER = "stereotypes.valueIsNotValidInteger",
    VALUE_IS_NOT_VALID_NUMBER = "stereotypes.valueIsNotValidNumber",
    VALUE_IS_NOT_VALID_TIME = "stereotypes.valueIsNotValidTime",
    VERSION = "stereotypes.version",
}
